{
  "valid": "Válido"
}
